<template>
  <v-container>
    <h2>¿Cómo Editar un Producto?</h2>
    <br />

    <v-card-actions class="justify-center">
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <h4>Editar</h4>
            Para poder editar algún campo de Productos.
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <li class="pa-3">
              Para poder editar algún producto en específico se tendrá que
              presionar el siguiente botón:
            </li>

            <li>
              <v-divider class="pa-4"></v-divider>
              <h4>Ejemplo:</h4>
              <v-container class="d-flex justify-center mb-6">
                <v-img
                  contain
                  max-height="550"
                  max-width="1000"
                  src="../assets/EditProduct.png"
                ></v-img>
              </v-container>
            </li>
            <v-divider class="pa-2"></v-divider>

            <li class="pa-4">
              Posteriormente se abrirá una pestaña con toda la información del
              producto elegido.
            </li>
            <v-container class="d-flex justify-center mb-6">
              <v-img
                contain
                max-height="550"
                max-width="1000"
                src="../assets/EditProduct_2.jpeg"
              ></v-img>
            </v-container>
            <li class="pa-3">
              Ahora el usuario podrá editar cualquier campo del producto
              elegido. Al momento que edite cualquier campo el botón
              <b>GUARDAR</b> se pondrá de color azul por lo que al momento de
              presionarlo se podrá editar los campos que el usuario haya
              elegido.
            </li>
            <v-container class="d-flex justify-center mb-6">
              <v-img
                contain
                max-height="550"
                max-width="1000"
                src="../assets/SafeButton.png"
              ></v-img>
            </v-container>
            <li class="pa-4">
              Al momento de darle <b>GUARDAR</b> saldrá un mensaje de
              confirmación.
            </li>
            <v-container class="d-flex justify-center mb-6">
              <v-img
                contain
                max-height="550"
                max-width="1000"
                src="../assets/SuccessProduct.jpeg"
              ></v-img>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>
            <h4>Eliminar</h4>
            Para eliminar algún campo de Productos.
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <li class="pa-3">
              Para eliminar algún producto en específico se tendrá que presionar
              el siguiente botón:
            </li>

            <li>
              <v-divider class="pa-2"></v-divider>
              <h4>Ejemplo:</h4>
              <v-container class="d-flex justify-center mb-6">
                <v-img
                  contain
                  max-height="550"
                  max-width="1000"
                  src="../assets/DeleteProduct.png"
                ></v-img
              ></v-container>
            </li>
            <li class="pa-3">
              Ahora para eliminar saldrá el nombre del producto del cual se
              eligió y posteriormente se hará click en el botón <b>ELIMINAR</b>
            </li>
            <li>
              <v-divider class="pa-2"></v-divider>
              <h4>Ejemplo:</h4>
              <v-container class="d-flex justify-center mb-6">
                <v-img
                  contain
                  max-height="550"
                  max-width="1000"
                  src="../assets/NameProduct.jpeg"
                ></v-img>
              </v-container>
            </li>
            <li class="pa-3">
              Por último saldrá un mensaje de confirmación de producto eliminado
              con éxito.
            </li>
            <li>
              <v-divider class="pa-2"></v-divider>
              <h4>Ejemplo:</h4>
              <v-container class="d-flex justify-center mb-6">
                <v-img
                  contain
                  max-height="550"
                  max-width="1000"
                  src="../assets/DeleteProduct_2.jpeg"
                ></v-img>
              </v-container>
            </li>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>
            <h4>Visualizar</h4>
            Para poder visualizar algún producto.
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <li class="pa-3">
              Para poder visualizar algún producto en específico se hará click
              en el siguiente botón:
            </li>
            <li>
              <h4>Ejemplo:</h4>
              <v-container class="d-flex justify-center mb-6">
                <v-img
                  class="pa-5"
                  contain
                  max-height="550"
                  max-width="1000"
                  src="../assets/VisualizeProduct.png"
                ></v-img>
              </v-container>
            </li>
            <li class="pa-5">
              Al hacer click en el botón de visualizar, aparecerá toda la
              información de producto.
            </li>
            <li>
              <h4>Ejemplo:</h4>
              <v-container class="d-flex justify-center mb-6">
                <v-img
                  class="pa-5"
                  contain
                  max-height="550"
                  max-width="1000"
                  src="../assets/DetailProduct.jpeg"
                ></v-img>
              </v-container>
            </li>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-actions>
  </v-container>
</template>

<script>
export default {
  name: "DocsProducts",

  data: () => ({}),
  reveal: false,
};
</script>
